import { jsonSchema7PrimitiveTypes } from "./constants.js";
export function isBooleanProperty(schema) {
    return typeof schema === 'boolean';
}
export function isSchema(schema) {
    return !isBooleanProperty(schema);
}
export function isOneOfSchema(schema) {
    return isSchema(schema) && Array.isArray(schema.oneOf);
}
export function isAnyOfSchema(schema) {
    return isSchema(schema) && Array.isArray(schema.anyOf);
}
export function isAllOfSchema(schema) {
    return isSchema(schema) && Array.isArray(schema.allOf);
}
export function isUnionSchema(schema) {
    return isOneOfSchema(schema) || isAnyOfSchema(schema) || isAllOfSchema(schema);
}
export function isObjectSchema(schema) {
    return isSchema(schema) && schema.type === 'object';
}
export function isObjectSchemaWithProperties(schema) {
    return isObjectSchema(schema) && typeof schema.properties === 'object';
}
export function isArraySchema(schema) {
    return isSchema(schema) && schema.type === 'array';
}
export function isListSchema(schema) {
    return isArraySchema(schema) && typeof schema.items === 'object' && !Array.isArray(schema.items);
}
export function isTupleSchema(schema) {
    return isArraySchema(schema) && Array.isArray(schema.items);
}
export function isEnumSchema(schema) {
    return Boolean(isSchema(schema) && schema.enum);
}
export function isConstSchema(schema) {
    return Boolean(isSchema(schema) && schema.const);
}
export function isRefSchema(schema) {
    return Boolean(isSchema(schema) && schema.$ref);
}
export function isTypeUnionSchema(schema) {
    return isSchema(schema) && Array.isArray(schema.type);
}
export function isPrimitiveSchema(schema) {
    if (typeof schema !== 'object') {
        return false;
    }
    if (isTypeUnionSchema(schema)) {
        return schema.type.every((t) => jsonSchema7PrimitiveTypes.includes(t));
    }
    return jsonSchema7PrimitiveTypes.includes(schema.type);
}
